const workHoursEnumerators = {
  status: ['submitted', 'rejected', 'accepted'],
};

export default workHoursEnumerators;
